export default 'asyncExample'
